import ProductBrandProvider from './hooks/useProductBrand';

import { ProductBrandProps } from './@types/ProductBrandProps';
import ProductBrandContainer from './handles/ProductBrandContainer';

const ProductBrand = (props: ProductBrandProps) => (
	<ProductBrandProvider {...props}>
		<ProductBrandContainer />
	</ProductBrandProvider>
);

export default ProductBrand;
